import './iconGrid.css';
import HexagonIcon from '../HexagonIcon/HexagonIcon';
import { ResponsiveHoneycomb } from 'react-honeycomb';

const IconGrid = ({ icons }) => {
  return (
    <ResponsiveHoneycomb
      defaultWidth={1024}
      size={60}
      items={icons}
      renderItem={item => <HexagonIcon text={item.text} imageSrc={item.imageSrc} />}
    />
  );
};

export default IconGrid;
